<template>
  <div class="w-full px-6 py-4">
    <div>
      <!-- Avatar -->
      <div class="flex space-x-4 mb-4">
        <o-field-group :label="$t('general.image')" :info="$t('components.employee.edit.details.avatarInfo')">
          <avatar-field :model="_employee" @click="handleUpdateImage" />
        </o-field-group>
      </div>

      <!-- Name -->
      <div class="flex space-x-4 mb-4">
        <o-field-group class="w-full md:w-1/2" :label="$t('general.firstName')">
          <div
            v-if="_employee.role.isRoleTypeOwner"
            class="bg-gray-50 dark:bg-gray-800 rounded-md flex items-center justify-between px-3"
          >
            <p class="text-sm py-[10px]">
              {{ _employee.firstName || '-' }}
            </p>

            <o-button
              size="sm"
              icon="edit"
              transparent
              @click="handleChangeEmail"
            />
          </div>

          <text-field v-else v-model="_employee.firstName" :label="$t('general.firstName')" />
        </o-field-group>

        <o-field-group class="w-full md:w-1/2" :label="$t('general.lastName')">
          <div
            v-if="_employee.role.isRoleTypeOwner"
            class="bg-gray-50 dark:bg-gray-800 rounded-md flex items-center justify-between px-3"
          >
            <p class="text-sm py-[10px]">
              {{ _employee.lastName || '-' }}
            </p>

            <o-button
              size="sm"
              icon="edit"
              transparent
              @click="handleChangeEmail"
            />
          </div>

          <text-field v-else v-model="_employee.lastName" :label="$t('general.lastName')" />
        </o-field-group>
      </div>

      <!-- Contact -->
      <div class="flex space-x-4 mb-4">
        <o-field-group
          v-slot="{ state }"
          class="w-full md:w-1/2"
          :label="$t('general.email')"
          :name="$t('general.email')"
          rules="email"
        >
          <div
            v-if="!_employee.isNewRecord"
            class="bg-gray-50 dark:bg-gray-800 rounded-md flex items-center justify-between px-3"
          >
            <p class="text-sm py-[10px]">
              {{ email || '-' }}
            </p>

            <o-button
              v-if="_employee.allow.changeEmail"
              size="sm"
              icon="edit"
              transparent
              @click="handleChangeEmail"
            />
          </div>

          <text-field
            v-if="_employee.isNewRecord"
            v-model="_employee.email"
            type="email"
            icon="MailIcon"
            :state="state"
          />
        </o-field-group>
        <o-field-group class="w-full md:w-1/2" :label="$t('general.mobileCell')">
          <text-field v-model="_employee.phone" icon="SmartphoneIcon" />
        </o-field-group>
      </div>

      <!-- Address -->
      <div class="flex space-x-4 mb-4">
        <o-field-group class="w-full" :label="$t('general.addressLine1')">
          <text-field v-model="_employee.address" />
        </o-field-group>
      </div>

      <div class="flex space-x-4 mb-4">
        <o-field-group class="w-full md:w-1/2" :label="$t('general.city')">
          <text-field v-model="_employee.city" />
        </o-field-group>

        <o-field-group class="w-full md:w-1/2" :label="$t('general.region')">
          <text-field v-model="_employee.region" />
        </o-field-group>
      </div>

      <div class="flex space-x-4 mb-4">
        <o-field-group class="w-full md:w-1/2" :label="$t('general.postcode')">
          <text-field v-model="_employee.postcode" />
        </o-field-group>
        <o-field-group class="w-full md:w-1/2" :label="$t('general.country')">
          <text-field v-model="_employee.country" />
        </o-field-group>
      </div>

      <!-- <div class="flex space-x-4 mb-4">
        <o-field-group class="w-full" label="Profile photo">
          <div class="flex w-full items-center space-x-2">
            <o-avatar :items="[ _employee ]" size="md" />

            <o-button size="sm" flat outline>
              Upload image
            </o-button>
            <o-button size="sm" variant="danger" flat>
              Remove
            </o-button>
          </div>
        </o-field-group>
      </div> -->

      <div class="flex space-x-4 mb-4">
        <o-field-group class="w-full" :label="$t('general.bio')">
          <text-area-field
            v-model="_employee.bio"
            rows="6"
            class="text-sm"
          />
        </o-field-group>
      </div>

      <!--<div class="flex space-x-4 mb-4">
        <o-field-group class="w-full md:w-1/2" label="Commission">
          <text-field v-model="_employee.comission" />
        </o-field-group>
      </div>-->

      <div class="flex space-x-4 mb-4">
        <o-field-group
          v-if="!isOwner || isAdmin"
          v-slot="{ status }"
          :label="$t('general.enabled')"
          :name="$t('general.enabled')"
          :info="enabledInfo"
          col
          reverse
          class="w-full md:w-1/2"
        >
          <toggle-field v-model="_employee.enabled" :status="status" :disabled="isOwner && _employee.enabled" />
        </o-field-group>

        <o-field-group
          v-slot="{ status }"
          :label="$t('general.allowOnlineBooking')"
          :name="$t('general.allowOnlineBooking')"
          :info="$t('employee.allowOnlineBookingInfo')"
          col
          reverse
          class="w-full md:w-1/2"
        >
          <toggle-field v-model="_employee.allowInternet" :status="status" />
        </o-field-group>
      </div>

      <div v-if="$features.get('loyalty')" class="flex space-x-4 mb-4">
        <o-field-group
          v-slot="{ status }"
          :label="$t('general.loyaltyEnabled')"
          :name="$t('general.loyaltyEnabled')"
          :info="$t('employee.loyaltyEnabledInfo')"
          col
          reverse
          class="w-full md:w-1/2"
        >
          <toggle-field v-model="_employee.loyaltyEnabled" :status="status" />
        </o-field-group>
      </div>

      <o-alert
        v-if="!_employee.isNewRecord"
        show
        :title="$t('components.employee.edit.details.role', { name: _employee.role.name })"
        variant="info"
        class="mb-6 mt-2"
      >
        <p class="text-sm mb-3">
          {{ employee.role.information }}
        </p>
        <i18n-t keypath="components.employee.edit.details.toChangeVisitAccountUsersAndRoles" tag="p" class="text-sm">
          <template #usersAndRoles>
            <a class="cursor-pointer" @click="handleOpenUsers">{{ $t('components.account.pages.usersAndRoles.label') }}</a>
          </template>
        </i18n-t>
      </o-alert>

      <div v-if="_employee.isNewRecord" class="flex space-x-4 mb-4">
        <o-field-group
          :label="$t('general.role')"
          :name="$t('general.role')"
          :info="$t('employee.setPermissions')"
          class="w-full md:w-1/2"
        >
          <role-select v-model="_employee.role" />
        </o-field-group>
      </div>

      <o-custom-fields :data="_employee.customFields">
        <template #default="{ fields }">
          <div
            v-for="field in fields"
            :key="field.props.id"
            class="flex space-x-4 mb-4"
          >
            <o-field-group class="w-full" :label="field.label">
              <component
                :is="field.component"
                v-bind="field.props"
                v-on="field.events"
              />
            </o-field-group>
          </div>
        </template>
      </o-custom-fields>
    </div>

    <update-image-dialog
      ref="updateImageDialog"
      :employee="_employee"
      @update="handleUpdateImageSuccess"
    />

    <change-email-modal
      ref="changeEmailModal"
      @success="handleChangeEmailSuccess"
    />
  </div>
</template>

<script setup lang="ts">
import { ref, computed, watch } from 'vue'

import ChangeEmailModal from '@/components/employee/actions/ChangeEmail.vue'
import RoleSelect from '@/components/roles/elements/Select.vue'
import UpdateImageDialog from '@/components/employee/actions/Image.vue'

import { OCustomFields, OAlert } from '@/components/elements'

import {
  TextField,
  TextAreaField,
  ToggleField,
  AvatarField,
} from '@/components/fields'

interface Props {
  employee: Record<string, any>
}

const props = defineProps<Props>()

const emit = defineEmits<{
  (e: 'update:employee', value: Record<string, any>): void
  (e: 'update'): void
}>()

const { $bus, $panel, $auth, $i18n } = useNuxtApp()
const router = useRouter()

const email = ref('')
const changeEmailModal = ref<any>()
const updateImageDialog = ref<any>()

const _employee = computed({
  get () {
    return props.employee
  },
  set (value) {
    emit('update:employee', value)
  },
})

const isAdmin = computed(() => !!$auth?.info?.adminUser)
const isOwner = computed(() => _employee.value?.role?.isRoleTypeOwner || _employee.value?.role?.type?.value === 'owner')
const enabledInfo = computed(() => {
  if (isOwner.value) {
    return $i18n.t('components.employee.edit.details.ownerEnabledInfo')
  }

  return $i18n.t('employee.allowAppAccessAndBookings')
})

watch(_employee, (employee) => {
  email.value = employee?.email
}, { immediate: true })

async function handleOpenUsers () {
  const path = '/account/team/users'
  const success = await ($panel as any).popToClear()

  if (success) {
    router.push(path)
  }
}

function handleChangeEmail () {
  changeEmailModal.value.open(_employee.value)
}

function handleChangeEmailSuccess (employee: any) {
  email.value = employee?.email
  emit('update')
}

function handleUpdateImage () {
  updateImageDialog.value.open()
}

function handleUpdateImageSuccess (employee: any) {
  _employee.value.images = employee.images
  _employee.value.hasImage = !!employee.images
  $bus.emit.updated('Employee')
}
</script>
